import { render, staticRenderFns } from "./SubscribeBenefits.vue?vue&type=template&id=74a430e9&scoped=true&"
import script from "./SubscribeBenefits.vue?vue&type=script&lang=js&"
export * from "./SubscribeBenefits.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeBenefits.vue?vue&type=style&index=0&id=74a430e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a430e9",
  null
  
)

export default component.exports